var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SdzModal",
    {
      ref: "modal",
      attrs: {
        "close-icon": true,
        width: _vm.$isMobile() ? "400" : "550",
        "custom-class": "reprove-modal",
        "hide-confirm-button": "",
        "hide-cancel-button": "",
      },
      on: { close: _vm.close },
      scopedSlots: _vm._u([
        {
          key: "buttons",
          fn: function () {
            return [
              _c(
                "v-btn",
                {
                  staticClass: "mb-3",
                  attrs: { color: "primary", outline: "", flat: "", large: "" },
                  on: { click: _vm.close },
                },
                [_vm._v("\n      Cancelar\n    ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "mb-3",
                  attrs: { color: "primary", large: "" },
                  on: { click: _vm.reprove },
                },
                [_vm._v("\n      Sim, reprovar revisão\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "v-layout",
        {
          staticClass: "pt-5 pb-2 px-5",
          attrs: {
            "align-center": "",
            column: "",
            "justify-center": "",
            wrap: "",
          },
        },
        [
          _c("img", {
            staticClass: "mb-4",
            attrs: {
              src: require(`@/assets/images/icons/info.svg`),
              width: "70",
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "modal-title" }, [
            _vm._v(
              "\n      Tem certeza que deseja reprovar a revisão da nota?\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "reprove-form" },
            [
              _c("AppTextArea", {
                attrs: {
                  rows: 3,
                  v: _vm.$v.reason,
                  label: "Motivo: ",
                  placeholder: "Justifique o motivo da reprovação",
                  "min-length": "20",
                  "max-length": "1000",
                  "hide-details": "",
                },
                model: {
                  value: _vm.reason,
                  callback: function ($$v) {
                    _vm.reason = $$v
                  },
                  expression: "reason",
                },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "counter mt-1 mb-0" }, [
                _vm._v(
                  "\n        " +
                    _vm._s((_vm.reason || "").length) +
                    " de 1000\n      "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "counter" }, [
                _vm._v("\n        *Mínimo 20 caracteres.\n      "),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }